import ScheduleDetailLayout from '@/layouts/ScheduleDetail';

export const unstable_settings = {
  initialRouteName: 'index',
};

export default function PrivateTabsOrganizationScheduleScheduleBEventIdLayoutRoute() {
  return (
    <ScheduleDetailLayout basePath="/organization/schedule/(scheduleB)/[eventId]" />
  );
}
